export function BreakpointIndicator() {
  if (process.env['NODE_ENV'] === 'production') return null;
  return (
    <>
      <div className="fixed bottom-16 left-16 z-50 flex h-6 w-6 items-center justify-center rounded-full bg-space p-3 font-mono text-xs text-white">
        <div className="block sm:hidden">xs</div>
        <div className="hidden sm:max-md:block">sm</div>
        <div className="hidden md:max-lg:block">md</div>
        <div className="hidden lg:max-xl:block">lg</div>
        <div className="hidden xl:max-2xl:block">xl</div>
        <div className="hidden 2xl:block">2xl</div>
      </div>
    </>
  );
}
